export default __webpack_public_path__ + "static/media/user-edit.32f4402c.svg";